module.exports = "/packs/images/sprites/social_enerprise_logo~00f5ee2210181e53d60d8f13e7340b3f.png";